/* eslint-disable max-lines */
/* eslint-disable vars-on-top */
/* eslint-disable  max-statements*/
/* eslint-disable no-undefined */
/* eslint-disable id-length */
/* eslint-disable complexity */
$(document).ready(function() {
  var newHomepage = 'Label-newHomePage',
      fullimagerespo = '#ph-fullImage-comp',
      largebannercomp = '.ph-mainLargeBanner',
      smallbannercomp = '.ph-mainSmallBanner';

  $('.ph-subnavigation .ph-headerparent__naviparent').each(function() {
    if ($(this).find('.ph-headerparent__navichild').is(':empty')) {
      $(this).addClass('ph-hidden');
    }
  });

  $('.ph-headerparent__navichild a').hover(function() {
    if (!$(this).parents('.ph-headerparent__naviparent').hasClass('ph-navselected')) {
      $(this).parents('.ph-headerparent__naviparent').addClass('ph-navactive');
    }
  },
  function() {
    if (!$(this).parents('.ph-headerparent__naviparent').hasClass('ph-navselected')) {
      $(this).parents('.ph-headerparent__naviparent').removeClass('ph-navactive');
    }
  });

  if ($('.page' + newHomepage).length > 0) {
    setTimeout(function() {
      if (($('#ph-fullImage-comp .ph-comp-respImageNew img').attr('src') === undefined) ||
    ($('#ph-fullImage-comp .ph-comp-respImageNew img').attr('src') === '')) {
        $(fullimagerespo).addClass('hidden');
      } else {
        $(fullimagerespo).removeClass('hidden');
      }

      if (($('.ph-mainLargeBanner .ph-smallbanners_img img').attr('src') === undefined) ||
    ($('.ph-mainLargeBanner .ph-smallbanners_img img').attr('src') === '')) {
        $(largebannercomp).addClass('hidden');
      } else {
        $(largebannercomp).removeClass('hidden');
      }

      if (($('.ph-mainSmallBanner .ph-smallbanners_img img').attr('src') === undefined) ||
    ($('.ph-mainSmallBanner .ph-smallbanners_img img').attr('src') === '')) {
        $(smallbannercomp).addClass('hidden');
      } else {
        $(smallbannercomp).removeClass('hidden');
      }
    }, 2000);
    setTimeout(function() {
      if (!$(smallbannercomp).is(':visible') && !$(fullimagerespo).is(':visible') &&
    !$(largebannercomp).is(':visible')) {
        $('#blue-part').addClass('hidden');
      }
    }, 4000);
  }

  // eslint-disable-next-line require-jsdoc
  function myTimer() {
    if (document.getElementById('smarteditoverlay') !== null) {
      var smarteditLen = document.getElementById('smarteditoverlay').childNodes.length;

      if (smarteditLen > 0 && smarteditLen !== null) {
        $(fullimagerespo).removeClass('hidden');
        $(largebannercomp).removeClass('hidden');
        $(smallbannercomp).removeClass('hidden');
        $('#blue-part').removeClass('hidden');
      }
    }
  }

  var myInterval = setInterval(myTimer, 6000);

  setTimeout(function() {
    clearInterval(myInterval);
  }, 300000);
});

$(document).ready(function() {
  var inputSearchPar = 'searchparent__input';

  function createUserEventObj(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  }

  function getProductObjectGoogleAnalytics(index) {
    var gaproductclass = '.ph-prodindex-' + index;

    return {
      id: 'MERCH_' + $(gaproductclass).attr('data-ctv'),
      locale: window.eddlContext.locale.code,
      quantity: parseInt($(gaproductclass).find('.ph-quantity').val(), 10)
    };
  }

  function trackMerchProdGoogleAnalytics(prodindex, totalProductItems) {
    var product = {},
        productsArray = [],
        index = 1,
        trigger = 'ecommerce.checkout.purchase';

    for (index = prodindex; index <= totalProductItems; index = index + 1) {
      product = getProductObjectGoogleAnalytics(index);
      productsArray.push(product);
    }

    ACC.googleanalytics.gaEventsForEcommerce(productsArray, trigger);
  }

  function expandHamburger() {
    var $searchInput = $('.ph-' + inputSearchPar),
        mobheadHamburg = 'headerparent__hamburgermobile';


    if ($('.ph-hamburgeractive').length === 0) {
      $('.ph-' + mobheadHamburg).toggleClass('ph-searchactive');
      $('.ph-hamburger__wrapper').toggleClass('hidden');
      $('.ph-headerparent__searchiconmobile').toggleClass('hidden');
      $('.ph-headerparent__primarysearchwrapper').toggleClass('ph-hidesearch');
      $searchInput.addClass('.ph-' + inputSearchPar);
      $('.ph-headerparent__primarysearchicon').removeClass('ph-colorchange');
      $('.ph-headerparent__primarysearchcross').removeClass('ph-opacity');
      $searchInput.val('');
      $('.ph-' + mobheadHamburg).toggleClass('ph-active');
      $searchInput.removeClass('ph-headerparent__searchbordercolor');
      $('.ph-headerparent__primarysearchicon').addClass('ph-colorchange');
      $('html').toggleClass('ph-overflow');
    }
  }

  $('.ph-headerparent__hamburgermobile').on('click', function() {
    expandHamburger();
  });

  $('.ph-headerparent__searchiconparentmobile').on('click', function() {
    expandHamburger();
  });

  $(document).on('click', '.ph-icon-login', function() {
    $('.ph-headerarent__tooltip').toggleClass('hidden');
    $('.ph-headerarent__tooltipmobile').toggleClass('hidden');
  });

  $(document).on('click', '.ph-searchmobilecross', function() {
    $('.ph-headerparent__searchwrappermobile').toggleClass('hidden');
  });
  $(document).on('focus', '.ph-searchparent__input', function() {
    $('.ph-headerparent__primarysearchicon').addClass('ph-colorchange');
    $('.ph-' + inputSearchPar).addClass('ph-colorchangeinput');
  });

  function searchpress(obj) {
    $('.ph-headerparent__primarysearchcross').addClass('ph-opacity');
    $(obj).addClass('ph-headerparent__searchbordercolor');
  }

  $(document).on('keypress', '.ph-searchparent__input', function() {
    searchpress(this);
  });
  $(document).on('keypress', '.ph-headerparent__searchinput', function() {
    searchpress(this);
  });
  $(document).on('keydown', '.ph-headerparent__searchinput', function() {
    searchpress(this);
  });
  $(document).on('mousedown', '.ph-headerparent__primarysearchcross', function() {
    $('.ph-' + inputSearchPar).val('');
    $(this).removeClass('ph-opacity');

    return false;
  });

  $.fn.disableScroll = function() {
    $('html, body').css({
      overflow: 'auto',
      height: 'auto'
    });
    $('.ph-support-contact-details-default').css('z-index', 3004);
  };

  $(document).on('click', '.ph-maincat-menu', function(event) {
    var $thisnext = $(this).next();
    var headerEle = '#header';
    var scrollie = 'ph-scrollie';

    event.preventDefault();

    $('.active').not(this).removeClass('active').next().hide();

    $(this).toggleClass('active');

    if (!$(this).next().is(':visible')) {
      $('.ph-subcathandl').hide();
    }

    $thisnext.toggle();


    if ($(this).next().is(':visible')) {
      $('html, body').css({
        overflow: 'hidden',
        height: '100%'
      });
      $('body').addClass(scrollie);
      $(headerEle).css({
        overflow: 'scroll',
        height: '100%'
      });
      $('.ph-support-contact-details-default').css('z-index', 3);
    } else {
      $('body').removeClass(scrollie);
      $(headerEle).css({
        overflow: 'visible',
        height: 'auto'
      });
      $.fn.disableScroll();
    }
  });

  $(document).on('click', '.ph-subcat__close', function() {
    $('.ph-maincat').removeClass('active');
    $('.ph-subcat').hide();
    $('body').removeClass('ph-scrollie');
    $('#header').css({
      overflow: 'visible',
      height: 'auto'
    });
    $.fn.disableScroll();
  });

  $(document).on('click', '.ph-maincat-mer', function() {
    var urlLink = ACC.config.encodedContextPath + '/merchandise/newMerchandiseCategory',
        desc = 'Merchandising Materials',
        trigger = 'linkCategory.clickMerchandise',
        compname = 'linkMerchandise',
        userEventObj = '';

    userEventObj = createUserEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  $(document).on('click', '#ph-merchcheckout__button', function() {
    var $productCtn = $('.ph-merchProductCode'),
        totalProductItems = $productCtn.length;

    trackMerchProdGoogleAnalytics(1, totalProductItems);
  });

  $(document).on('click', '.ph-uspbarcontent .ph-readmoreflyout', function() {
    var url = window.location.href,
        clickdescription = 'Click on USP Bar - ',
        desc = clickdescription + $(this).text().trim(),
        trigger = 'linkCategory.clickUSPbar',
        compname = 'linkUSPbar',
        userEventObj = '';

    userEventObj = createUserEventObj(url, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
});

$(document).ready(function() {
  var $siteLinks = $('.ph-sitelinks'),
      $checkboxes = $('.ph-facetcat__form').find('input:checkbox'),
      $filterClear = $('.ph-unselect-all'),
      $parent = '',
      filterElements = '',
      $filterUrl = '',
      searchtext = '',
      toolText = 'tool-tip-text';

  $(document).on('mouseenter', '.p-footer-country', function() {
    $siteLinks.removeClass('hidden');
  });

  $(document).on('mouseenter', '.ph-sitelinks', function() {
    $siteLinks.removeClass('hidden');
  });

  $(document).on('mouseleave', '.p-footer-country', function() {
    $siteLinks.addClass('hidden');
  });

  $(document).on('mouseleave', '.ph-otherlinks', function() {
    $siteLinks.addClass('hidden');
  });

  $(document).on('mouseover', '.ph-tool-tip', function() {
    $(this).find('.ph-' + toolText).removeClass('hidden');
  });

  $(document).on('mouseleave', '.ph-tool-tip', function() {
    $(this).find('.ph-' + toolText).addClass('hidden');
  });

  $(document).on('mouseover', '.ph-tool-tip-contract', function() {
    var toolHeight = $(this).find('.ph-' + toolText).height(),
        sampleHeight = $('.ph-sampleHeight').height(),
        flyHei = parseInt(toolHeight, 10) / parseInt(sampleHeight, 10),
        flyHeight = Math.round(flyHei);
    var heightArray = [
      1,
      2,
      3,
      4,
      5,
      6
    ];
    var cssheightArray = [
      '-58px',
      '-78px',
      '-100px',
      '-120px',
      '-144px',
      '-164px'
    ];

    for (var counter = 0; counter < 7; counter = counter + 1) {
      if (flyHeight === heightArray[counter]) {
        $('.ph-tool-tip-text').css('top', cssheightArray[counter]);
      }
    }
  });

  $(document).on('click', '#ph-shopping-rdo-btn', function() {
    $('.ph-forminput').focus();
  });

  $(document).on('click', '.ph-unselect-all', function() {
    var completeUrl = window.location.href;
    var clearFilterUrl = completeUrl.split('?q').splice(0, 1).join();

    if (window.location.href.indexOf('%3A') > -1) {
      $filterUrl = completeUrl.split('%3A')[0];

      location.replace($filterUrl);
    }


    if (window.location.href.indexOf('search') > -1 && completeUrl.indexOf('text=') > -1) {
      searchtext = completeUrl.split('text=')[1];
      $filterUrl = clearFilterUrl + '?text=' + searchtext;

      location.replace($filterUrl);
    } else {
      location.replace(clearFilterUrl);
    }
  });


  $filterClear.addClass('hidden');

  $checkboxes.each(function() {
    if ($(this).is(':checked')) {
      $filterClear.removeClass('hidden');
    }
  });

  $('.ph-filter-popup-open').on('click', function() {
    $parent = $('.ph-filter-popup');
    $parent.addClass('ph-open');
    filterElements = '';
    filterElements = $('#ph-filterDesktop').find('.ph-filter').clone();
    $('.ph-filter-popup-body').html(filterElements);
  });

  $('.ph-filter-popup-close').on('click', function() {
    $parent = $(this).closest('.ph-filter-popup');
    $parent.removeClass('ph-open');
    filterElements = '';
    filterElements = $('.ph-filter-popup-body').find('.ph-filter').clone();
    $('#ph-filterDesktop').html(filterElements);
  });
});
/* Banner component changes*/

$(document).ready(function() {
  if ($('.pageLabel-login #signin-content').length > 0) {
    var videostr = $('#ph-videoBack-color').val(),
        imgNewStr = $('.ph-login-informationSlot #ph-bannerImage-color').val(),
        videoMob = 'ph-vedio',
        statImgMob = '-statImgMob',
        statBannerImg = 'ph-static',
        videoBanner = '-banner',
        empty = 'ph-empty',
        bgColor = '-color',
        bground = 'background',
        statImgBgColor = '',
        vidBackColor = '';

    vidBackColor = videostr.split('_');
    statImgBgColor = imgNewStr.split('_');

    $('#ph-vedio' + videoBanner).css('background' + bgColor, '#' + vidBackColor[1]);
    $('.ph-LogintabImage').css(bground + '-color', '#' + statImgBgColor[1]);
    $('#' + videoMob + '-bannerMob').css('background' + bgColor, '#' + vidBackColor[1]);
    $('#ph-class' + statImgMob).css(bground + '-color', '#' + statImgBgColor[1]);


    var $img = $('#ph-class-statImg .ph-static-bannerImg img'),
        $leftImg = $('#ph-class-statImg .ph-static' + statBannerImg + ' img'),
        $mobImg = $('#ph-class' + statImgMob + ' .ph-static-bannerImg img'),
        $leftMobImg = $('#ph-class-statImgMob .ph-static-bannerImgLeft img');

    if ($img.attr('src') === '' || $leftImg.attr('src') === '') {
      $('#ph-class-statImg').addClass(empty + '-comp');
      $('.ph-static-bannerImgLeft').addClass('ph-empty-noMargin');
    }

    if ($mobImg.attr('src') === '' || $leftMobImg.attr('src') === '') {
      $('#ph-class-statImgMob,.ph-class-mob').addClass(empty + '-comp');
      $('#left-nextComp').removeClass('ph-static-bannerImg');
      $('.ph-static-bannerImg').addClass('ph-empty-noMargin');
    }

    if ($('.ph-vedio_banner').length === 0) {
      $('#ph-vedio' + videoBanner + ',#ph-vedio-bannerMob').addClass('ph-empty-comp');
      $('.ph-middle-banner').css('margin', '0');
      $('#' + videoMob + '-bannerMob #left-comp').removeClass('ph-vediobanner-section');
      $('#ph-vedio-bannerMob #right-comp').removeClass('ph-class-vidMob');
    }
  }

  function addMargin() {
    window.scrollTo(0, window.pageYOffset - 120);
  }

  if ($('.ph-termwholecontainer').length > 0 || $('.ph-faqwholecontainer').length > 0) {
    window.addEventListener('hashchange', addMargin);
  }

  $('a[href=\'#00\']').click(function() {
    $('html, body').animate({
      scrollTop: 100
    }, 'fast');

    return false;
  });
});
$(document).ready(function() {
  /* Top banner */
  if ($('.pageLabel-newHomePage').length > 0) {
    var str = $('#ph-newHome-text-color').val(),
        newStr = $('#ph-newHome-bg-color').val(),
        txtColor = '',
        bgColor = '';

    if (str !== undefined && newStr !== undefined) {
      txtColor = str.split('_');
      bgColor = newStr.split('_');

      if ($(window).width() > 600) {
        $('.ph-NewHome-topBanner-text').css('color', '#' + txtColor[1]);
      } else {
        $('.ph-NewHome-topBanner-text').css('color', '#000');
      }

      $('.ph-NewHome-topBanner-btn').css('color', '#' + txtColor[1]);
      $('.ph-NewHome-topBanner-btn').css('background-color', '#' + bgColor[1]);
      $('.ph-NewHome-topBanner-btnHead').css('border', '1px solid #' + txtColor[1]);
    }

    if ($('.pageLabel-newHomePage .ph-uspbarwholecontainer').length === 0 && $('.pageLabel-newHomePage .ph-countdownbarcontainer').length === 0) {
      $('.ph-image-sectionNewHome').addClass('ph-newHome-m');
    }
  }
  /* Portfolio price list call from dashboard */

  $('.ph-priceList').click(function() {
    $.ajax({
      url: ACC.config.encodedContextPath + '/productPriceListExcel/download',
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        if (result === 'Success') {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            /* eslint-disable xss/no-mixed-html*/
            html: $('.ph-pbreportgeneration').html(),
            /* eslint-enable xss/no-mixed-html*/
            overlayClose: true,
            onComplete: function() {
              $('.ph-pbgeneratereportredirect').attr('href', ACC.config.encodedContextPath + '/reports?reporttrigger');
            },
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        }
      },
      error: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });
});
$(document).ready(function() {
  var textCol = $('#ph-promo-color').val(),
      bannerTextCol = $('#ph-smallbannertext-color').val(),
      bannerColStr = '',
      imageTextCol = $('#ph-imagetext-color').val(),
      imageColStr = '',
      uspBgColor = $('#ph-usb_bgcolor').val(),
      uspTxtColor = $('#ph-usb_txtcolor').val(),
      colStr = '',
      countdownbarcontainer = '.ph-countdownbarcontainer',
      uspbarwholecontainer = '.ph-uspbarwholecontainer',
      checkoutbar = '#shopping-cart-content .ph-checkouthdr',
      newSupportpageBanner = '.ph-newSupportpageBanner',
      newDecpageBanner = '.ph-newDecpageBanner',
      newHomepageBanner = '.ph-newrespobannerhomepage',
      margintopstyl = 'margin-top',
      topnewnav = '.ph-topnewnav',
      tempProductlist = 'template-pages-category-productListPage',
      promocolor = '#ph-promo-color',
      largeBannerComponent = '.ph-imagetext_comp',
      largeBannerBgColor = $(largeBannerComponent).find('#ph-bannerImage-color').val(),
      largeBannerTxtColor = $(largeBannerComponent).find('#ph-smallbannertext-color').val(),
      largeBannerBgColorStr = '',
      largeBannerTxtColorStr = '',
      bannerPromotionText = '.ph-banner-promotion',
      bannerbtnText = '.ph-bannerBtn',
      bannerBreakout = $(newHomepageBanner).find('.breakout'),
      homepageImages = bannerBreakout.find('figure'),
      pxSolid = '1px solid ';


  if (textCol !== undefined) {
    colStr = textCol.split('_');

    $(bannerPromotionText).css('color', '#' + colStr[1]);
    $(bannerbtnText).css('color', '#' + colStr[1]);
    $(bannerbtnText).css('border', pxSolid + '#' + colStr[1]);

    if ($(promocolor).length > 0 && $('body').hasClass(tempProductlist)) {
      $('ul.ph-breadcrumb li a,ul.ph-breadcrumb li').css('color', '#' + colStr[1]);
    }
  }

  if (textCol === '') {
    if ($(promocolor).length > 0 && $('body').hasClass(tempProductlist)) {
      $('ul.ph-breadcrumb li a,ul.ph-breadcrumb li').css('color', '#3C3C3C');
    }
  }

  $('.ph-promo-color').each(function() {
    var textColrotate = $(this).val();

    if (textColrotate !== undefined) {
      colStr = textColrotate.split('_');

      $(this).siblings(bannerPromotionText).css('color', '#' + colStr[1]);
      $(this).siblings(bannerbtnText).css('color', '#' + colStr[1]);
      $(this).siblings(bannerbtnText).css('border', pxSolid + '#' + colStr[1]);
    }
  });

  if (bannerTextCol !== undefined) {
    bannerColStr = bannerTextCol.split('_');

    $(largeBannerComponent).find('.ph-nologin').css('color', '#' + bannerColStr[1]);
  }

  if (uspBgColor !== undefined) {
    $('.ph-uspbarwholecontainer').css('background', uspBgColor);
  }

  if (uspTxtColor !== undefined) {
    $('.ph-uspbarcontent').css('color', uspTxtColor);
  }

  if (imageTextCol !== undefined) {
    imageColStr = imageTextCol.split('_');

    $(largeBannerComponent).find('.ph-nologin').css('background', '#' + imageColStr[1]);
  }

  if (largeBannerBgColor !== undefined) {
    largeBannerBgColorStr = largeBannerBgColor.split('_');
    $(largeBannerComponent).find('.mini_container_text').css('background', '#' + largeBannerBgColorStr[1]);
  }

  if (largeBannerTxtColor !== undefined) {
    largeBannerTxtColorStr = largeBannerTxtColor.split('_');
    $(largeBannerComponent).find('.mini_container_text').css('color', '#' + largeBannerTxtColorStr[1]);
  }

  if ($(countdownbarcontainer).length > 0) {
    $(checkoutbar).css(margintopstyl, '0px');
    $(newSupportpageBanner).attr('style', 'margin-top: 4px !important');
    $(newDecpageBanner).attr('style', 'margin-top: 4px !important');
  } else {
    $(checkoutbar).css(margintopstyl, '-16px');
    $(newSupportpageBanner).attr('style', 'margin-top: -17px !important');
    $(newDecpageBanner).attr('style', 'margin-top: -17px !important');
  }

  if ($(countdownbarcontainer).length > 0) {
    $(newHomepageBanner).attr('style', 'margin-top: 21px !important');
  } else if ($(uspbarwholecontainer).length > 0) {
    $(newHomepageBanner).attr('style', 'margin-top: -5px !important');
  } else {
    $(newHomepageBanner).attr('style', 'margin-top: -5px !important');
  }

  if ($(newHomepageBanner).length > 0 && $(homepageImages).length === 0) {
    $('#main-header').css('height', 'auto');
  }


  if ($(window).width() <= 1023) {
    if ($(countdownbarcontainer).length > 0) {
      $(newHomepageBanner).attr('style', 'margin-top: 15px !important');
    } else if ($(uspbarwholecontainer).length > 0) {
      $(newHomepageBanner).attr('style', 'margin-top: -11px !important');
    } else {
      $(newHomepageBanner).attr('style', 'margin-top: -6px !important');
    }
  }

  if ($(window).width() <= 960) {
    if ($(countdownbarcontainer).length > 0) {
      $(checkoutbar).css(margintopstyl, '24px');
    } else {
      $(checkoutbar).css(margintopstyl, '9px');
    }
  }

  if ($(window).width() <= 1023) {
    if ($(countdownbarcontainer).length > 0) {
      $(newSupportpageBanner).attr('style', 'margin-top: 24px !important');
      $(newDecpageBanner).attr('style', 'margin-top: 21px !important');
    } else {
      $(newSupportpageBanner).attr('style', 'margin-top: 0px !important');
      $(newDecpageBanner).attr('style', 'margin-top: 0px !important');
    }
  }

  if ($(promocolor).length > 0 && $('body').hasClass(tempProductlist)) {
    $('.ph-top-newNavigation').addClass('ph-topnewnav');

    if ($(window).width() <= 700) {
      if ($(countdownbarcontainer).length > 0) {
        $(topnewnav).attr('style', 'margin-top: 245px!important');
      } else {
        $(topnewnav).attr('style', 'margin-top: 235px !important');
      }
    }
  }

  if ($(promocolor).length === 0 && $('body').hasClass(tempProductlist)) {
    $('.ph-top-newNavigation').removeClass('ph-topnewnav');
    $('.ph-middleContent').addClass('ph-withoutbannercontent');
  }
});

$(document).ready(function() {
  var $filterHeding = $('.ph-filter__heading'),
      dropdownMenuCls = '.ph-header_b2bunitname-selectBox-dropdown-menu',
      logToolTip = '.ph-loggedin-tooltip';

  $(document).on('click', '.ph-decisionpage__optionicon', function() {
    $('.ph-decisionpage-menutooltip').toggleClass('hidden');
  });

  $(document).on('click', '.ph-cartpage__optionicon', function() {
    $('.ph-cartpage-menutooltip').toggleClass('hidden');
  });


  $(document).on('click', '.ph-headerparent__humanicon', function() {
    $(logToolTip).toggleClass('hidden');
    $('.ph-support-contact-details-default').removeClass('ph-activeFold');
    $('.ph-icon-supportFold-left').removeClass('ph-icon-supportFold-left-toggle');
  });

  $(document).on('click', '.ph-header__tooltipclose', function() {
    $(logToolTip).addClass('hidden');
    $(dropdownMenuCls).addClass('hidden');
  });
  $(document).on('click', '.ph-header_b2bunitname, .selectBox-dropdown', function() {
    var dropdownMenu = '.desk_b2bunit-selectBox-dropdown-menu';

    $(dropdownMenu).css('position', 'fixed');
    $(dropdownMenu).css('top', '192px');
  });
  /* Close the menu pop up on outside click */

  $('body').on('click', function(event) {
    if (!$(logToolTip).is(event.target) && $(logToolTip).has(event.target).length === 0 &&
      !$('.ph-humanicon').is(event.target) && !$('.ph-header__profilename').is(event.target)) {
      $(logToolTip).addClass('hidden');
    }
  });

  if ($('.ph-facetcheckbox').length === 0) {
    $('.ph-filter-popup-button-wrapper').addClass('ph-removefilter');
  } else {
    $('.ph-filter-popup-button-wrapper').removeClass('ph-removefilter');
    $filterHeding.removeClass('ph-removefilterhead');
  }

  if ($('#lang-form').length === 0) {
    $('.ph-footerlang').addClass('hidden');
  }

  if ($('.ph-homepage__customericon').length > 0) {
    $('.ph-banner__cont').addClass('ph-banner__content');
    $('.ph-footer__component').addClass('ph-footer__padding');
  }

  if ($('.ph-facetcheckbox').length === 0) {
    $filterHeding.addClass('hidden');
  }

  $(document).find('.ph-printer').on('click', function(event) {
    event.preventDefault();
    window.print();
  });
});

$(document).ready(function() {
  var fieldNamePlus = '',
      inputName = '',
      currentVal = '',
      maxValue = '',
      minValue = '',
      fieldNameMinus = '',
      pageSelected = 'ph-backto_pageselected',
      quoteCheckout = 'page-quoteCheckoutSummaryPage',
      merchCheckout = 'page-merchandiseCheckout',
      middlecontent = '.ph-middleContent',
      focCartValue = $('.ph-isfocCart').val();

  /* Page specific template*/

  if ($('#top-navigation-wrapper').length > 0) {
    $(middlecontent).addClass('ph-norm-template');
  } else {
    $(middlecontent).addClass('ph-new-template');
  }

  $('.ph-qtyplus').click(function(event) {
    event.preventDefault();

    fieldNamePlus = $(this).attr('field');
    inputName = 'input[name=';
    currentVal = parseInt($(inputName + fieldNamePlus + ']').val(), 10);
    maxValue = parseInt($(inputName + fieldNamePlus + ']').attr('max'), 10);

    if (maxValue > currentVal) {
      $(inputName + fieldNamePlus + ']').val(currentVal + 1).trigger('blur');
    }
  });

  $('.ph-qtyminus').click(function(event) {
    event.preventDefault();

    fieldNameMinus = $(this).attr('field');
    inputName = 'input[name=';
    currentVal = parseInt($(inputName + fieldNameMinus + ']').val(), 10);
    minValue = parseInt($(inputName + fieldNameMinus + ']').attr('min'), 10);

    if (minValue < currentVal) {
      $(inputName + fieldNameMinus + ']').val(currentVal - 1).trigger('blur');
    }
  });

  if ($('body').hasClass(quoteCheckout) || $('body').hasClass(merchCheckout) ||
   $('.ph-quoteIdFromSession').length > 0 || focCartValue === 'true' || $('.checkout_isZoomCart').val() === 'true') {
    $('.ph-logo-link').addClass(pageSelected);
    $('.ph-headerparent__tooltipheading, .ph-headerparent__categorymobile').addClass(pageSelected);
    $('.ph-notificationicon').addClass(pageSelected);
    $('#miniCartIcon').addClass(pageSelected);
    $('.ph-subcatname, .ph-responsivesub__cat').addClass(pageSelected);

    $('.ph-menu-item').each(function() {
      var check = $(this).find('a').is('.ph-maincat.ph-maincat-menu');

      if (!check) {
        $(this).find('a').addClass(pageSelected);
      }
    });

    $('.ph-icon-facebook, .ph-icon-twitter, .ph-icon-linkedin').addClass(pageSelected);
    $('.ph-icon-youtube, .ph-icon-pinterest').addClass(pageSelected);
    $('.p-bullets-footer a').addClass(pageSelected);
    $('.ph-indsitelinks a').addClass(pageSelected);
    $('.ph-support-links').addClass(pageSelected);
    $('#cm-link').removeClass(pageSelected);
    $('.ph-newSearchIcon').css('pointer-events', 'none');

    if ($('.quantity-balloon').length === 0) {
      $('.ph-switchstoredesk .ph-da-switch').addClass(pageSelected);
      $('.ph-signout').addClass(pageSelected);
    } else {
      $('.ph-switchstoredesk .ph-da-switch').removeClass(pageSelected);
      $('.ph-signout').removeClass(pageSelected);
    }
  }
});

$(window).on('load', function() {
  var width = $('.ph-image-sectionNew').width(),
      noLogin = 'ph-nologin';

  if (width < 100) {
    $('#signin-content').addClass('ph-addposition');
  }

  if ($('.pageLabel-newHomePage').length > 0) {
    var bannerHeight = [];
    var maxHeightBanner = '';

    $('.ph-mainSmallBanner').find('.' + noLogin).each(function() {
      bannerHeight.push($(this).height());
    });
    maxHeightBanner = Math.max.apply(Math, bannerHeight);
    $('.ph-mainSmallBanner').find('.' + noLogin).height(maxHeightBanner);
  }

  $('.ph-banner').each(function() {
    var bannerTitle = $(this).attr('title'),
        bannerRenderText = $(bannerTitle).text();

    $(this).attr('title', bannerRenderText);
  });
});
/* eslint-enable max-lines */
/* eslint-enable vars-on-top */
/* eslint-enable max-statements*/
/* eslint-enable no-undefined */
/* eslint-enable id-length */
/* eslint-enable complexity */
